import { useState, useEffect } from 'react';

export default function BarItem({
  title,
  score,
  maxScore,
  formattedScore,
  color,
  label,
  alignBarTitle,
  notApplicable = false
}) {
  const [animatedWidth, setAnimatedWidth] = useState('0%');
  const [animatedScore, setAnimatedScore] = useState(0);
  const animationSpeed = 25; // pixels per second

  useEffect(() => {
    if (notApplicable) return undefined;

    const targetWidthPercentage = (score / (maxScore || 1) * 100);
    const duration = (targetWidthPercentage / animationSpeed) * 1000;

    let elapsed = 0;

    const interval = setInterval(() => {
      elapsed += 10;
      if (elapsed >= duration) {
        clearInterval(interval);
        setAnimatedWidth(`${targetWidthPercentage.toFixed(2)}%`);
        setAnimatedScore(formattedScore ? parseFloat(formattedScore.toFixed(2)).toString() : 0);
      } else {
        const progress = elapsed / duration;
        setAnimatedWidth(`${(targetWidthPercentage * progress).toFixed(2)}%`);
        setAnimatedScore(Math.round(score * progress));
      }
    }, 10);

    return () => clearInterval(interval);
  }, [score, maxScore, formattedScore, notApplicable]);

  const scoreStyle = {
    width: animatedWidth,
    ...(color && { backgroundColor: color }) // Add backgroundColor property if color prop exists
  };

  return (
    <li>
      <span className={`analysis-title ${alignBarTitle}`} dangerouslySetInnerHTML={{ __html: title }}/>
      <span className="analysis-score-wrapper">
        {notApplicable ? (
          <span className="analysis-not-applicable">not applicable</span>
        ) : (
          <span
            className="analysis-score"
            style={scoreStyle}
          >
            <span>{animatedScore}{label}</span>
          </span>
        )}
      </span>
    </li>
  );
};
